import { motion } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useInboxMutePolicy } from '@frontend/inbox-mute-policy';
import { useMessagingAIRCustomizationFlag } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { Text, NakedButton } from '@frontend/design-system';
import { AiDrawerItem } from './ai-drawer-item';
import { buttonStyles, MenuOption } from './thread-options-drawer';

type ThreadOptionsMenuProps = {
  groupId: string;
  threadId: string;
  locationPhone: string;
  setSelectedMenu: (newVal: MenuOption | undefined) => void;
  hideOptions?: MenuOption[];
  associatedContactsCount?: number;
  /** True when thread is calculated but doesn't exist yet (new conversation) */
  isNew?: boolean;
};

export const ThreadOptionsMenu = ({
  groupId,
  threadId,
  locationPhone,
  setSelectedMenu,
  hideOptions = [],
  associatedContactsCount,
  isNew,
}: ThreadOptionsMenuProps) => {
  const { t } = useTranslation('mini-chat');
  const { isActive: isFusionEnabled } = useMessagingAIRCustomizationFlag([groupId]);
  const { isHidden } = useInboxMutePolicy();

  return (
    <motion.div layout='position'>
      {isFusionEnabled && !isHidden('ai-receptionist-thread-toggle') && (
        <AiDrawerItem threadId={threadId} groupId={groupId} locationPhone={locationPhone} isNew={isNew} />
      )}

      {!hideOptions.includes('change-thread') && (
        <NakedButton
          css={buttonStyles}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setSelectedMenu('change-thread');
          }}
          trackingId='mini-chat-change-thread-button'
        >
          <span
            css={{
              display: 'flex',
              gap: theme.spacing(1),
              alignItems: 'center',
            }}
          >
            <Icon name='message-thread-small' />
            <Text>{t('Change Thread')}</Text>
          </span>
          <span
            css={{
              display: 'flex',
              gap: theme.spacing(1),
              alignItems: 'center',
            }}
          >
            <Icon name='caret-right-small' />
          </span>
        </NakedButton>
      )}
      {!hideOptions.includes('associated-contacts') && (
        <NakedButton
          css={buttonStyles}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setSelectedMenu('associated-contacts');
          }}
          trackingId='mini-chat-associated-contacts-button'
        >
          <span
            css={{
              display: 'flex',
              gap: theme.spacing(1),
              alignItems: 'center',
            }}
          >
            <Icon name='family-small' />
            <Text>{t('Associated Contacts')}</Text>
          </span>
          <span
            css={{
              display: 'flex',
              gap: theme.spacing(1),
              alignItems: 'center',
            }}
          >
            {associatedContactsCount && (
              <Text color='light' size='small'>
                {associatedContactsCount}
              </Text>
            )}
            <Icon name='caret-right-small' />
          </span>
        </NakedButton>
      )}
    </motion.div>
  );
};
